import { fromPairs } from 'lodash';
import { connect } from 'react-redux';

import * as CliAppDefinition from 'app/entities/CliAppDefinition';
import * as DeveloperActions from 'app/developer-v3/Actions';
import * as EnvironmentVariable from 'app/entities/EnvironmentVariable';
import AuthenticationEditorWrapper from 'app/developer-v3/pages/authentication/AuthenticationEditor/AuthenticationEditorWrapper';
import LoadingBlockOrComponent from 'app/common/components/LoadingBlockOrComponent';
import hocify from 'app/common/components/hocify';
import {
  currentAppDefinitionEntity,
  currentAppVersion,
  currentDefinitionOverrideClean,
  currentPlatformVariablesList,
  currentRequestTemplate,
  isCurrentAppDefinitionSaving,
} from 'app/developer-v3/selectors';
import { SERVICE_TYPE } from 'app/developer-v3/constants';

const mapStateToProps = state => {
  const currentAppDefinition = currentAppDefinitionEntity(state);
  const currentOverride = currentDefinitionOverrideClean(state);
  const authentication = currentOverride.authentication;
  const authenticationLegacy = currentOverride.legacy?.authentication;
  const triggersDefinition = currentOverride.triggers;
  const requestTemplate = currentRequestTemplate(state);
  const isSaving = isCurrentAppDefinitionSaving(state);
  const environment = fromPairs(
    EnvironmentVariable.selectors.all
      .environmentVariablesForVersion(
        CliAppDefinition.selectors.appId(currentAppDefinition),
        currentAppVersion(state),
        state
      )
      .map(env => {
        return [
          EnvironmentVariable.selectors.key(env),
          EnvironmentVariable.selectors.value(env),
        ];
      })
  );

  // auth fields
  const oAuthRedirectUri = CliAppDefinition.selectors.isOauth2(
    currentAppDefinition
  )
    ? CliAppDefinition.selectors.oauthRedirectUri(currentAppDefinition)
    : '';
  const fields =
    CliAppDefinition.selectors.authFields(currentAppDefinition) || [];

  const isLoading =
    CliAppDefinition.selectors.all.isLoading(state) ||
    EnvironmentVariable.selectors.all.isLoading(state);

  return {
    authentication,
    authenticationLegacy,
    getSuggestions: currentPlatformVariablesList(
      SERVICE_TYPE.authentication,
      state
    ),
    isLoading,
    isSaving,
    environment,
    oAuthRedirectUri,
    fields,
    requestTemplate,
    triggersDefinition,
  };
};

const mapDispatchToProps = (dispatch, props) => ({
  onLoad() {
    dispatch(DeveloperActions.resetTestRequest());
    dispatch(DeveloperActions.resetTestLogs());
    dispatch(DeveloperActions.loadEnvironmentForVersion());
  },

  onDeleteConnectionLabelCode() {
    dispatch(DeveloperActions.deleteConnectionLabelCode());
  },

  onDeleteTestCode() {
    dispatch(DeveloperActions.deleteAuthenticationTestCode());
  },

  onSaveAuthenticationSettings(authenticationSettings) {
    dispatch(
      DeveloperActions.saveAuthenticationSettings(authenticationSettings)
    );
  },

  deleteAuthenticationField(key) {
    dispatch(DeveloperActions.deleteAuthField(key));
  },

  setUnsavedChanges(hasUnsavedChanges: boolean) {
    dispatch(DeveloperActions.setUnsavedChanges(hasUnsavedChanges));
  },

  async getTestLogs() {
    const { id, version } = props.params;
    await dispatch(DeveloperActions.getAllTestLogs(id, version));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(hocify(LoadingBlockOrComponent)(AuthenticationEditorWrapper));
